import {
  CREATE_MANUAL_ASSET_READING_SUCCESS,
  FETCH_MANUAL_ASSET_LAST_READING_SUCCESS,
  FETCH_MANUAL_ASSET_LAST_READING_WITH_TIME_SUCCESS,
  FETCH_MANUAL_ASSET_READING_SUCCESS,
  GET_MANUAL_ASSET_READING_SUCCESS,
  SAVE_MANUAL_ASSET_READING_QUERY
} from "../../constants/ActionTypes";

const INIT_STATE = {
  total: 0,
  resources: [],
  resource: {},
  edit: {},
  query: {},
  lastReading: null,
  lastReadingWithTime: null,
};

export default (state = INIT_STATE, action) => {
  switch (action.type) {
    case SAVE_MANUAL_ASSET_READING_QUERY: {
      return {
        ...state,
        query: action.query
      }
    }

    case GET_MANUAL_ASSET_READING_SUCCESS: {
      const query = { ...state.query };
      if (query && query.pagination)
        query.pagination.total = action.count;

      return {
        ...state,
        query: query,
        resources: action.data,
        total: action.total,
      }
    }

    case CREATE_MANUAL_ASSET_READING_SUCCESS: {
      return {
        ...state,
        resource: action.data,
      }
    }

    case FETCH_MANUAL_ASSET_READING_SUCCESS: {
      return {
        ...state,
        edit: action.data,
      }
    }
    case FETCH_MANUAL_ASSET_LAST_READING_SUCCESS: {
      return {
        ...state,
        lastReading: action.data,
      }
    } case FETCH_MANUAL_ASSET_LAST_READING_WITH_TIME_SUCCESS: {
      const key = `${action.assetId}-${action.meterId}-${action.timestamp}`
      return {
        ...state,
        lastReadingWithTime: {
          ...state.lastReadingWithTime,
          [key]: action.data
        }
      }
    }


    default:
      return state;
  }
}
